
























import Vue from 'vue'
import { remittanceFeeController } from '~/api/Remittances/remittances.api'
import AppView from '~/components/AppView.vue'
import { TableHeader } from '~/utils/interfaces'
import {
  DeliveryCurrenciesEnum,
  RemittanceFee,
} from '~/utils/interfaces/remittance.interface'

export default Vue.extend({
  components: { AppView },
  data() {
    return {
      controller: remittanceFeeController,
      headers: [
        {
          text: this.$t('fee'),
          value: 'fee',
        },
        {
          text: this.$t('delivery_currency'),
          value: 'delivery_currency',
        },
        {
          text: this.$t('is_active'),
          value: 'is_active',
        },
        {
          text: this.$t('actions'),
          value: 'actions',
        },
      ] as TableHeader<RemittanceFee>[],
      defaultCrud: {
        fee: '',
        delivery_currency: '',
      },
      deliveryCurrencies: Object.values(DeliveryCurrenciesEnum),
    }
  },
})
